























































import api from '@/services/api';
import {Component, Vue} from 'vue-property-decorator';
import UserProfile from '@/classes/UserProfile';
import {LoginRoute} from '@/services/Authorize';
import 'bootstrap';
import bootbox from 'bootbox';
import _ from 'underscore';

@Component
export default class ResetPassword extends Vue {
    public newPassword: string = '';
    public password: string = '';

    public created() {
        if (this.$store.state.activeProfile === undefined) {
            this.$router.push(LoginRoute);
        }
    }

    public async sendForm() {
        if (this.password !== this.newPassword) {
            return;
        }

        try {

            await api().post('resetpassword', {password: this.password});
            await this.$store.dispatch('initializeUserProfile', true);
            await this.$router.push('home');

        } catch (err) {
            this.$bvToast.toast('There was a problem resetting your password.', {
                title: 'Error',
                solid: true,
                variant: 'danger'
            });
        }
    }

    public async logOut() {

        try {
            await api().post('logout');
            this.$store.commit('setActiveProfile', undefined);
            await this.$router.push(LoginRoute);
        } catch (err) {
            // TODO...
        }
    }

    get expiredPassword(): boolean {
        const activeProfile = this.$store.getters.getActiveProfile || {};
        return true === activeProfile.passwordExpired;
    }

    get checkPasswordsMatch(): boolean | null {
        if (this.newPassword !== '' && this.password !== '') {
            return this.newPassword === this.password;
        } else {
            return null;
        }
    }

    get checkPasswordComplexity(): string[] {
        const password: string = this.newPassword;
        const errors: string[] = [];
        const regExpDigit = /(?=.*\d)/;
        if (!regExpDigit.test(password)) {
            errors.push('Password contain at least one numeric digit [0 - 9]');
        }
        const regExpLower = /(?=.*[a-z])/;
        if (!regExpLower.test(password)) {
            errors.push('Password contain at least one lower case character [a - z]');
        }
        const regExpUpper = /(?=.*[A-Z])/;
        if (!regExpUpper.test(password)) {
            errors.push('Password contain at least one upper case character [A - Z]');
        }
        const regExpSpecial = /(?=.*[~!#$%\^&*_\-+=`|\\{}[\]:;"'<>,\.?@\/])/;
        if (!regExpSpecial.test(password)) {
            errors.push('Password contain at least one special character [ ~!#$%^&*_-+=`|\\{}[]:;"\'<>,.?/@ ]');
        }
        return errors;
    }

    get checkPasswordLength(): string[] {
        const password: string = this.newPassword;
        const errors: string[] = [];
        if (password.length < 8) {
            errors.push('Password must be at least 8 characters.');
        }
        return errors;
    }

    get isValidPassword(): boolean | null {
        return _.isEmpty(this.newPassword) ? null :
            this.checkPasswordComplexity.length <= 1 && this.checkPasswordLength.length < 1;
    }
}
